module.exports = __webpack_public_path__ + "img/gpay-icon-white.b938fba9.svg";